module.exports = __webpack_public_path__ + "img/bannerlooser-p-1080.32fcc76d.png";